/**
 * STU (Studievaardig) Module Seeds - DDD Canonical Location
 *
 * 21 families, all imports local (./STU-*.json).
 */

import STU_ALFABET from './STU-ALFABET.json';
import STU_COMBINEER from './STU-COMBINEER.json';
import STU_GRAFIEK from './STU-GRAFIEK.json';
import STU_INHOUDSOPGAVE from './STU-INHOUDSOPGAVE.json';
import STU_KAART from './STU-KAART.json';
import STU_TABEL from './STU-TABEL.json';
import STU_STAAF from './STU-STAAF.json';
import STU_LIJN from './STU-LIJN.json';
import STU_CIRKEL from './STU-CIRKEL.json';
import STU_WOORDENBOEK from './STU-WOORDENBOEK.json';
import STU_DIAGRAM from './STU-DIAGRAM.json';
import STU_BIBLIOTHEEK from './STU-BIBLIOTHEEK.json';
import STU_TIJDLIJN from './STU-TIJDLIJN.json';
import STU_INTERNET from './STU-INTERNET.json';
import STU_FLOWCHART from './STU-FLOWCHART.json';
import STU_SAMENVATTEN from './STU-SAMENVATTEN.json';
import STU_NOTITIES from './STU-NOTITIES.json';
import STU_PLANNEN from './STU-PLANNEN.json';
import STU_ROUTE from './STU-ROUTE.json';
import STU_MINDMAP from './STU-MINDMAP.json';
const STU_FAMILY_SEEDS = [{
  file: 'src/content/seeds/STU/STU-ALFABET.json',
  data: STU_ALFABET
}, {
  file: 'src/content/seeds/STU/STU-COMBINEER.json',
  data: STU_COMBINEER
}, {
  file: 'src/content/seeds/STU/STU-GRAFIEK.json',
  data: STU_GRAFIEK
}, {
  file: 'src/content/seeds/STU/STU-INHOUDSOPGAVE.json',
  data: STU_INHOUDSOPGAVE
}, {
  file: 'src/content/seeds/STU/STU-KAART.json',
  data: STU_KAART
}, {
  file: 'src/content/seeds/STU/STU-TABEL.json',
  data: STU_TABEL
}, {
  file: 'src/content/seeds/STU/STU-STAAF.json',
  data: STU_STAAF
}, {
  file: 'src/content/seeds/STU/STU-LIJN.json',
  data: STU_LIJN
}, {
  file: 'src/content/seeds/STU/STU-CIRKEL.json',
  data: STU_CIRKEL
}, {
  file: 'src/content/seeds/STU/STU-WOORDENBOEK.json',
  data: STU_WOORDENBOEK
}, {
  file: 'src/content/seeds/STU/STU-DIAGRAM.json',
  data: STU_DIAGRAM
}, {
  file: 'src/content/seeds/STU/STU-BIBLIOTHEEK.json',
  data: STU_BIBLIOTHEEK
}, {
  file: 'src/content/seeds/STU/STU-TIJDLIJN.json',
  data: STU_TIJDLIJN
}, {
  file: 'src/content/seeds/STU/STU-INTERNET.json',
  data: STU_INTERNET
}, {
  file: 'src/content/seeds/STU/STU-FLOWCHART.json',
  data: STU_FLOWCHART
}, {
  file: 'src/content/seeds/STU/STU-SAMENVATTEN.json',
  data: STU_SAMENVATTEN
}, {
  file: 'src/content/seeds/STU/STU-NOTITIES.json',
  data: STU_NOTITIES
}, {
  file: 'src/content/seeds/STU/STU-PLANNEN.json',
  data: STU_PLANNEN
}, {
  file: 'src/content/seeds/STU/STU-ROUTE.json',
  data: STU_ROUTE
}, {
  file: 'src/content/seeds/STU/STU-MINDMAP.json',
  data: STU_MINDMAP
}] as const;
const allQuestions = STU_FAMILY_SEEDS.flatMap(({
  file,
  data
}) => data.questions.map(question => ({
  ...question,
  __sourceFile: file
})));
export default {
  module: 'Studievaardig' as const,
  moduleCode: 'STU',
  version: '5.2-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions
};